module.exports = __webpack_public_path__ + "static/MediaWiki-5a04a45a69f695519f8c8d24bb0f392f.svg";